<template>
    <div class="backBox">
        <van-loading v-show="pageLoading" type="spinner" color="#1989fa" class="page-loading">加载中...</van-loading>
        <div v-show="DOMToast" class="dom-toast" v-html="message"></div>
        <div v-show="!pageLoading" class="pad">
            <div v-if="tabNum!=''" class="tab-box">
                <div :class="tabNum===1?'tab-active':''" @click="tabNum=1">待取件</div>
                <div :class="tabNum===2?'tab-active':''" @click="tabNum=2">已完成</div>
            </div>
            <van-list v-if="tabNum===1" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadCabinets">
                <div v-for="(item,index) in cabinetsData" :key="index" class="cabinet-box" >
                    <div class="cabinet-title" @click="lookCabinetDetail(1,item.id)">
                        <span>存包时间：{{item.gmtCreated}}</span>
                        <span>详情</span>
                    </div>
                    <div class="cabinet-content">
                        <div class="info">
                            <div class="label">存包柜信息：</div>
                            <div>{{item.location}}</div>
                        </div>
                        <div class="info">
                            <div class="label">存储时长：</div>
                            <div>{{item.timeDiff}}</div>
                        </div>
                        <div class="flash">
                            <div>存包格：<span class="cabinet-num blue">{{item.number}}#</span></div>
                            <van-button v-if="isFlashBtnShow" type="info" class="flash-btn" color="#286EFF" round @click="flash">一闪取包</van-button>
                            <div v-else style="font-size: 12px;color: #999999">当前版本过低,请更新</div>
                        </div>
                    </div>
                </div>
            </van-list>
            <van-list v-if="tabNum===2" v-model="tLoading" :finished="tFinished" finished-text="没有更多了" @load="onLoadTakeOutCabinets">
                <div class="cabinet-box" v-for="(item,index) in tCabinetsData" :key="index" >
                    <div class="cabinet-title" @click="lookCabinetDetail(2,item.id)">
                        <span>取包时间：{{item.checkOutTime}}</span>
                        <span>详情</span>
                    </div>
                    <div class="cabinet-content">
                        <div class="info"><div class="label">存包柜信息：</div><div>{{item.location}}</div></div>
                        <div class="info"><div class="label">存储时长：</div><div>{{item.timeDiff}}</div></div>
                        <div class="flash">
                            <div>存包格：<span class="cabinet-num gray">{{item.number}}#</span></div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import { Button ,List ,Toast ,Loading} from "vant";
import api from "@/api/storage";
import { blindFlash ,faceIdentifyInApp ,getAppVersion } from "@/util/jsbridge";
import compareVersion from "@/util/formatVersion";

export default {
    name: "Cabinets",
    components:{
        [Button.name]:Button,
        [List.name]:List,
        [Loading.name]:Loading,
    },
    data(){
        return{
            tabNum:"",
            loading:false,
            finished:false,
            page:0,
            pageSize:5,
            cabinetsData:[],
            tPage:0,
            tCabinetsData:[],
            tLoading:false,
            tFinished:false,
            isFlashBtnShow:true,
            pageLoading:false,
            DOMToast:false,
            message:""
        }
    },
    beforeCreate(){
        let self=this;
        api.isHaveData({
            type:"Storage"
        }).then(res=>{
            if(res.result===0){
                if(res.data.count===0){
                    self.$router.replace({name:"ad"});
                }else {
                    self.tabNum=1;
                }
            }else {
                Toast(res);
            }
        })
    },
    created(){
        getAppVersion(this.showAppVersion);
    },
    mounted(){
        window.flashResultBackFromApp = this.flashResultBackFromApp;
        window.faceIdentifyResultBackFromApp = this.faceIdentifyResultBackFromApp;
    },
    methods:{
        showAppVersion(version){
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                if(compareVersion(version,"3.2.16")){  //3.2.16(包含)后新版可以使用app闪光
                    this.isFlashBtnShow=true;
                }else {
                    this.isFlashBtnShow=false;
                }
            } else {
                if(compareVersion(version,"3.2.6")){  //3.2.6(包含)后新版可以使用app闪光
                    this.isFlashBtnShow=true;
                }else {
                    this.isFlashBtnShow=false;
                }
            }
        },
        onLoadCabinets(){
            api.getCabinets({
                page:++this.page,
                pageSize:this.pageSize,
                type:"Storage",
                // Express查询快递柜信息
            }).then(res=>{
                if(res.result===0){
                    let self=this;
                    self.loading=false;
                    if(res.data.result.length>0){
                        try {
                            res.data.result.forEach(function (n) {
                                self.cabinetsData.push(n);
                                if(self.cabinetsData.length<res.data.total){
                                    self.finished = false;
                                }else {
                                    throw "";
                                }
                            });
                        }catch (e) {
                            self.finished=true;
                        }
                    }else{
                        self.finished=true;
                    }
                }else {
                    Toast(res);
                }
            })
        },
        onLoadTakeOutCabinets(){
            api.getTakeOutCabinets({
                page:++this.tPage,
                pageSize:this.pageSize,
                type:"Storage",
            }).then(res=>{
                if(res.result===0){
                    let self=this;
                    self.tLoading=false;
                    if(res.data.result.length>0){
                        try {
                            res.data.result.forEach(function (n) {
                                self.tCabinetsData.push(n);
                                if(self.tCabinetsData.length<res.data.total){
                                    self.tFinished = false;
                                }else {
                                    throw "";
                                }
                            });
                        }catch (e) {
                            self.tFinished=true;
                        }
                    }else{
                        self.tFinished=true;
                    }
                }else {
                    Toast(res);
                }
            })
        },
        flash(){
            blindFlash();
            this.pageLoading=true;
        },
        lookCabinetDetail(type,id){
            this.$router.push({name:"cabinetDetail",query:{type:type,id:id}});
        },


        flashResultBackFromApp(flashResultStr) {
            let flashResult = eval( '(' + flashResultStr + ')');
            if ("toast" == flashResult.mode) {
                this.DOMToast=true;
                this.message=flashResult.message;
                let self=this;
                setTimeout(function () {
                    self.DOMToast=false;
                },3000);
                this.pageLoading=false;
                this.cabinetsData=[];
                this.page=0;
                this.onLoadCabinets();
            } else if ("url" == flashResult.mode) {
                if(flashResult.url){
                    window.location.href=flashResult.url
                }
                this.pageLoading=false;
                this.cabinetsData=[];
                this.page=0;
                this.onLoadCabinets();
            } else if ("face" == flashResult.mode) {
                faceIdentifyInApp(flashResult.authMode, flashResult.outNumber, flashResult.notifyUrl)
            }else {
                if(flashResult.message){
                    this.DOMToast=true;
                    this.message=flashResult.message;
                    let self=this;
                    setTimeout(function () {
                        self.DOMToast=false;
                    },3000);
                }else {
                    Toast("出了点小状况");
                }
                this.pageLoading=false;
                this.cabinetsData=[];
                this.page=0;
                this.onLoadCabinets();
            }
        },

        faceIdentifyResultBackFromApp(faceResultStr) {
            let faceResult = eval('(' + faceResultStr + ')');
            this.pageLoading=false;
            this.cabinetsData=[];
            this.page=0;
            this.onLoadCabinets();
            if ("toast" == faceResult.mode) {
                this.DOMToast=true;
                this.message=faceResult.message;
                let self=this;
                setTimeout(function () {
                    self.DOMToast=false;
                },3000);
            } else if ("url" == faceResult.mode) {
                if(faceResult.url){
                    window.location.href=faceResult.url
                }
            }else {
                if(faceResult.message){
                    this.DOMToast=true;
                    this.message=faceResult.message;
                    let self=this;
                    setTimeout(function () {
                        self.DOMToast=false;
                    },3000);
                }else {
                    Toast("出了点小状况");
                }
            }
        },
    }
}
</script>

<style scoped lang="less">
@import "../../../static/less/common";
.dom-toast{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 99;
    border-radius: 4px;
    box-shadow: 0 0 15px 0 rgba(153,153,153,0.7);
    padding: 5px 10px;
    background: #ffffff;
}
.page-loading{
    margin-top: 40vh;
    text-align: center;
}
.cabinet-box{
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 7px 16px 0 rgba(0,0,0,0.05);
    margin-bottom: 10px;
    .cabinet-title{
        border-bottom: 1px dashed #727272;
        height: 35px;
        font-size: 14px;
        color: #999999;
        .flex-center-Y;
        justify-content: space-between;
    }
    .cabinet-content{
        padding-top: 15px;
        font-size: 14px;
        .info{
            margin-bottom: 20px;
            .flex-center-Y;
            .label{
                white-space: nowrap
            }
        }
        .flash{
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            height: 35px;
            .cabinet-num{
                font-size: 30px;
                font-weight: bolder;
            }
            .blue{
                color: #286EFF;
            }
            .gray{
                color: #999999;
            }
            .flash-btn{
                width: 100px;
                height: 36px;
                line-height: 30px;
                font-size: 16px;
            }
        }
    }
}
</style>
<style>
    .flash-btn .van-button__text{
        width: 100%;
    }
</style>
